import { UuidViewModel } from './uuid.view-model';
import { ViewModelBase } from './view-model-base';

export class UuidCollectionViewModel extends ViewModelBase {
  declare public uuids: UuidViewModel[];
}
